import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input';

import PropTypes from 'prop-types';
import { getCurLanuagePhone } from '../../business/phoneNumber';

import type { SelectChangeEvent } from '@mui/material/Select';

interface LCountrySelectProps {
  label: string;
  handleChange: (event: SelectChangeEvent<string>, child?: React.ReactNode) => void;
  value: string;
  i18n: any;
  inputStyle?: React.CSSProperties;
  SelectStyle?: React.CSSProperties;
  name: string;
  variant?: 'outlined' | 'filled' | 'standard';
  fullWidth?: boolean;
}

const LCountrySelect: React.FC<LCountrySelectProps> = ({fullWidth=true, inputStyle, SelectStyle, label, handleChange,  value, i18n, name, variant = 'outlined' }) => {
  const labels = getCurLanuagePhone(i18n);
  return (
    <FormControl fullWidth={fullWidth} required >
      <InputLabel style={inputStyle} id="demo-simple-select-label">{label}</InputLabel>
      <Select
        style={SelectStyle}
        variant={variant}
        name= {name}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label= {name}
        onChange={handleChange}
      >
        {getCountries().map((country) => (
          <MenuItem key={country} value={getCountryCallingCode(country)}>{labels[country]}</MenuItem>

        ))}
      </Select>
    </FormControl>
  );};

export default LCountrySelect;